/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemSyncStatusBatchRequestSchema = z.object({
  itemIds: z.array(z.int()).refine((items) => new Set(items).size === items.length, {
    message: 'Array entries must be unique',
  }),
});
